module.exports = "/assets/career/team/jakub_zakrzewski.png?T6VKGAX";